import {
  MotionBox as Box,
  MotionFlex as Flex,
  MotionGrid as Grid,
  staggeredAppear,
  appearBelow,
} from "utils/motion";
import { GridItem } from "@chakra-ui/react";
import Text from "components/base/Text";

const TextValue = (props) => <Text type="p_lg" textAlign="center" {...props} />;

const TextLabel = (props) => (
  <Text type="title_xs" mt={[1, null, 0]} textAlign="center" {...props} />
);

export default function HorizontalSpecs({
  label1,
  value1,
  label2,
  value2,
  label3,
  value3,
  label4,
  value4,
  label5,
  value5,
  isInverted,
  props,
}) {
  return (
    <Flex
      variants={staggeredAppear}
      initial="hidden"
      color={isInverted ? "white" : "black.900"}
      whileInView="visible"
      viewport={{ once: false, amount: 0.2 }}
      width={["100%", null, "auto"]}
      height="100%"
      alignItems={["flex-end", null, "center"]}
      justifyContent="center"
      bg={isInverted ? "black.900" : "white"}
      pb="200px"
      mx={["xs", null, "xl"]}
      {...props}
    >
      <Grid
        templateColumns={["repeat(2, 1fr)", null, "repeat(5, 1fr)"]}
        gap={["40px", null, "60px", "80px"]}
      >
        <Box justifySelf="center" variants={appearBelow}>
          <TextValue color={isInverted ? "white" : "black.900"}>
            {label1}
          </TextValue>
          <TextLabel color={isInverted ? "white" : "black.900"}>
            {value1}
          </TextLabel>
        </Box>

        <Box justifySelf="center" variants={appearBelow}>
          <TextValue color={isInverted ? "white" : "black.900"}>
            {label2}
          </TextValue>
          <TextLabel color={isInverted ? "white" : "black.900"}>
            {value2}
          </TextLabel>
        </Box>

        <Box justifySelf="center" variants={appearBelow}>
          <TextValue color={isInverted ? "white" : "black.900"}>
            {label3}
          </TextValue>
          <TextLabel color={isInverted ? "white" : "black.900"}>
            {value3}
          </TextLabel>
        </Box>

        <Box justifySelf="center" variants={appearBelow}>
          <TextValue color={isInverted ? "white" : "black.900"}>
            {label4}
          </TextValue>
          <TextLabel color={isInverted ? "white" : "black.900"}>
            {value4}
          </TextLabel>
        </Box>
        <GridItem colSpan={[2, 2, 1, 1]}>
          <Box justifySelf="center" variants={appearBelow}>
            <TextValue color={isInverted ? "white" : "black.900"}>
              {label5}
            </TextValue>
            <TextLabel color={isInverted ? "white" : "black.900"}>
              {value5}
            </TextLabel>
          </Box>
        </GridItem>
      </Grid>
    </Flex>
  );
}
